<template lang="pug">
  div
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3154.9489470417943!2d-122.19707048501016!3d37.74434192168355!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f85951f8df8af%3A0x452b9190c143a8b2!2sCity%20of%20Refuge%20UCC!5e0!3m2!1sen!2sus!4v1581886022300!5m2!1sen!2sus" width="100%" height="300"  frameborder="0" style="border:0;" allowfullscreen=""></iframe>
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped></style>
